<template>
<EditAudioFeatureModal
    :showModal="current_feature_edit_box != null ? true : false"
    :closeModal="closeEditFeatureModal"
    featureName="Audioguide"
    :changeUploadBoxState="changeUploadBoxState"
    :current_edit_feature_id="current_edit_feature_id"
/>
</template>

<script>
import EditAudioFeatureModal from './AudioGuide/EditAudioFeatureModal';
import { changeUploadBoxState, selectFileFromMediaLibrary } from '@/Pages/Media/MediaLibraryLogic.js';

export default {
    components: {
        EditAudioFeatureModal,
    },
    props: [
        'current_feature_edit_box',
        'closeEditFeatureModal',
        'current_edit_feature_id'
    ],
    methods:{
        changeUploadBoxState: changeUploadBoxState,
    }
}
</script>